import React from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import Inputs from '../../Components/Inputs/Inputs';
import Icons from "../../Components/Icons/Icons";
import FiltersComponent from "../../Components/FiltersComponent";
import {searchFuntion,findArrayIndex} from '../../Utils/CommonFunctions';

const CreateNew = (props) => {
    const {isCreateNewModelOpen,addFormFields,addFilters,deleteFitler,windowsList,windowFields,valueChangeHandler,
            filtersChangeHandler,filterDrillDownChangeHandler,saveHandler,toggleModel,fieldGroups,window_info,windowInfoChangeHandler,
            relatedWindowFields,addTopFilter} = props;
    const {operation_name,operation_type,window_type,description,filters,status,window_data} = addFormFields;
    console.log(addFormFields)
    let windowList = [];
    if(relatedWindowFields && relatedWindowFields.window_fields) {
        Object.keys(relatedWindowFields.window_fields).map(function(key) {
            windowList.push(key);
        })      
    }

    let fieldOptions = [{label: "~None~", value: ""}];
    if(relatedWindowFields && relatedWindowFields.window_fields) {
        windowList.map((windArr,windInd) => {
            let label = '';
            let options = [];
            label = windArr;
            relatedWindowFields.window_fields[windArr].map((field,ind) => {
                options.push({label: field.field_name, value: field.id,fieldtype:field.field_type})
            })
            fieldOptions.push({label:label,options:options})
        })
    }

    const changeHandler = (data) => {
        const {index,name,value} = data;
        
        if(name === "drillDown") {
            const {table_descriptor_id,field_name,field_type,fieldTypeId,options,lookupName,filters,optionsArr,absolute_window,
                absolute_window1,filterObject,fieldFilterId,selectedFieldObj,lookupWindowNameId,lookupWindowName,isNotes,addFilters} = value;
            const val = {
                tableDescriptorId: table_descriptor_id,
                fieldFilterId: fieldFilterId,
                fieldFilter: filters,
                values: [],
                lineNumber: 1,
                logicalOperator: "0",
                filterObject: filterObject,
                fieldType: field_type,
                fieldTypeId : fieldTypeId,
                multiSelectOptions : optionsArr,
                lookupWindowName : '',
                absolute_window : absolute_window,
                absolute_window1 : absolute_window1,
                lookupWindowNameId : lookupWindowNameId,
                lookupWindowName : lookupWindowName,
                isNotes : isNotes
            }
            filterDrillDownChangeHandler(val,index);
        }else if(name === "fieldFilterId") {
            const data = findFiltersOjectByFilterIdAndFilterArray(value, filters[index]['fieldFilter']);
            filtersChangeHandler("filterObject",data,index);
            filtersChangeHandler(name,value,index);
        }else if(name === "tableDescriptorId") {
            const filterDataVal = findFilterObjByFilterId(value,relatedWindowFields.window_fields);
            const fieldOpt = getOptionsUsingId(fieldOptions,value);
            const filterdata = filterDataVal.filters;
            const options = filterDataVal.options;
            let optionsArr = [];
            if(options.length > 0) {
              options.map((arr,i) => {
                const value = {
                  "value": arr.key,
                  "label": arr.value,
                }
                optionsArr.push(value);
                return true;
              }) 
            }

            let fieldFilterId = '';
            let filterObject = null;

            if(filterdata && filterdata.length > 0) {
                if(filterdata[0].name === 'is changed') {
                    fieldFilterId = filterdata[1].filterId;
                    filterObject = filterdata[1];
                }else {
                    fieldFilterId = filterdata[0].filterId;
                    filterObject = filterdata[0];
                }
            }
            const val = {
                tableDescriptorId: filterDataVal.id,
                fieldFilterId: fieldFilterId,
                fieldFilter: filterdata,
                values: [],
                lineNumber: 1,
                logicalOperator: "and",
                filterObject: filterObject,
                fieldType: filterDataVal.field_type,
                fieldTypeId : filterDataVal.fieldTypeId,
                multiSelectOptions : optionsArr,
                // lookupWindowName : '',
                // absolute_window : absolute_window,
                // absolute_window1 : absolute_window1,
                // lookupWindowNameId : lookupWindowNameId,
                // lookupWindowName : lookupWindowName,
                // isNotes : isNotes
            }
            filterDrillDownChangeHandler(val,index);
        }else {
            filtersChangeHandler(name,value,index);
        }
    }

    const findFilterObjByFilterId = (id,windArr) => {
        let obj = {};
        // const windowFields = this.state.reportPreviewFields.window_fields;
        const windowFields = windArr;
        Object.keys(windowFields).map(function(key) {
            windowFields[key].map((windArr,windInd) => {
              if(windArr.id === id) {
                obj=windArr;
              }
            })
        })
        return obj;
    }

    const getOptionsUsingId = (optionArr,ide) => {
        let returnData = null;
        if(optionArr) {
          optionArr.map((arr,ind) => {
            if(arr.options) {
              arr.options.map((arr1,ind1) => {
                if(arr1.value === ide) {
                  returnData = arr1;
                }
              })
            }
          })
        }
        return returnData;
      }

    const findFiltersOjectByFilterIdAndFilterArray = (filterId, filterArray) => {
        let data = [];
        if(filterArray) {
            filterArray.map((arr,i) => {
                if(arr.filterId === filterId) {
                    data = arr;
                }
            })
        }
        return data;
    }
    // console.log(filters)
    return (
		<Modal size="xl" show={props.isCreateNewModelOpen}>
            <Modal.Header>
                <h4 className="modal-title secondary_color pl-2 mb-0"> Add Automation Process </h4>
            </Modal.Header>
            <Modal.Body className="workFlow_rules">
                <div className="row">
                    <div className="col-6">
                        <div className={operation_name.error !== "" ? "form-group has-error" : "form-group" }>
                            <label> {operation_name.title} </label>
                            <div>
                                <Inputs fieldName={operation_name.name} formData={JSON.stringify(operation_name)} changed={e=>valueChangeHandler(e.target.value,operation_name.name)} />
                                {operation_name.error !== "" ? 
                                    <label className="error m-0">{operation_name.error}</label>
                                    : null
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className={operation_type.error !== "" ? "form-group has-error" : "form-group" }>
                            <label> {operation_type.title} </label>
                            <div>
                                <Inputs fieldName={operation_type.name} formData={JSON.stringify(operation_type)} changed={e=>valueChangeHandler(e,operation_type.name)}/>
                                {operation_type.error !== "" ? 
                                    <label className="error m-0">{operation_type.error}</label>
                                    : null
                                }
                            </div>
                        </div>
                    </div>

                    

                    <div className="col-12">
                        <div className="row">
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-title">Choose Window</div>
                                    </div>
                                    <div className="card-body pt-0 pl-2 pr-2">
                                        <div className={window_data.error !== "" ? "form-group has-error mb-0 mt-2" : "form-group mb-0 mt-2" }>
                                            <input type="search" 
                                                onChange={e=>searchFuntion(e.target.value,'mainWind')}
                                                className="form-control form-control-sm" 
                                                placeholder="search here" aria-controls="add-row" />
                                            {window_data.error !== "" ? 
                                                <label className="error m-0">{window_data.error}</label>
                                                : null
                                            }
                                        </div> 
                                        <div className="card-list parent_Mapping fixed-height overflowY-auto">
                                            <ul className="m-0 p-0">
                                            {
                                                fieldGroups ?
                                                    fieldGroups.map((fieldArr,fieldInd) => {
                                                        const windId = window_info.window_id;
                                                        return (
                                                            <li onClick={e=>windowInfoChangeHandler('window_id', fieldArr.window_id )} className={ windId === fieldArr.window_id ? "item-list active mainWind justify-content-between px-3 bg-light" : "item-list mainWind justify-content-between px-3 cursor-pointer" } key={fieldInd}>
                                                                <span className="card-title"> {fieldArr.window_name} </span>
                                                                { windId === fieldArr.window_id ?
                                                                    <span>  
                                                                        <i className="fas fa-check primary_color"></i> 
                                                                    </span> 
                                                                : null }
                                                                
                                                            </li>
                                                        )
                                                    })
                                                : null
                                            }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-title">Choose Related Windows</div>
                                    </div>
                                    <div className="card-body pt-0 pl-2 pr-2">
                                        <div className="form-group mb-0 mt-2">
                                            <input type="search" 
                                            onChange={e=>searchFuntion(e.target.value,'relatedWind')}
                                            className="form-control form-control-sm" 
                                            placeholder="search here" aria-controls="add-row" />
                                        </div>
                                        <div className="card-list fixed-height overflowY-auto">
                                            <ul className="m-0 p-0">
                                            {
                                                window_info.related_window ?
                                                    window_info.related_window.map((relFieldArr,relFieldInd) => {
                                                        return (
                                                            <li className="item-list relatedWind" key={relFieldInd}>
                                                                <span className="">
                                                                {
                                                                    //props.data.window_info.relatedSelWindow.indexOf(relFieldArr.window_id) === -1 ?
                                                                    findArrayIndex(relFieldArr.table_descriptor_id,window_info.relatedSelWindow) === -1 ?
                                                                        <input type="checkbox" onChange={e=>windowInfoChangeHandler('related_window', relFieldArr.window_id, relFieldArr.table_descriptor_id )}  id={relFieldInd} value={relFieldArr.window_id} checked={false} disabled={window_info.relatedSelWindow.length > 2 ? true : false}/>
                                                                    :
                                                                        <input type="checkbox" onChange={e=>windowInfoChangeHandler('related_window', relFieldArr.window_id, relFieldArr.table_descriptor_id )}  id={relFieldInd} value={relFieldArr.window_id} checked={true} />
                                                                }
                                                                    <label htmlFor={relFieldInd} className="pl-2 card-title cursor-pointer"> {relFieldArr.window_name} </label> 
                                                                </span>                                              
                                                            </li>
                                                        )
                                                    })
                                                : null
                                            }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*<div className="col-3">
                        <div className="form-group">
                            <label> {window_type.title} </label>
                            <div>
                                <Inputs fieldName={window_type.name} formData={JSON.stringify(window_type)} changed={e=>valueChangeHandler(e,window_type.name)} />
                            </div>
                        </div>
                    </div>*/}

                    

                    <div className="col-10">
                        <div className="form-group">
                            <label> {description.title} </label>
                            <div>
                                <Inputs fieldName={description.name} formData={JSON.stringify(description)} changed={e=>valueChangeHandler(e.target.value,description.name)}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-2">
                        <div className="form-group">
                            <label> {status.title} </label> 
                            <Inputs fieldName={status.name} formData={JSON.stringify(status)} changed={e=>valueChangeHandler(e.target.checked,status.name)} />
                        </div>
                    </div>

                    <div className={filters && Array.isArray(filters) && filters.length>0 ? "col-12 float-left hide" : "col-12 float-left"}>
                        <div className="clear"></div>
                        <div className="form-group">
                            <ol className="workFlow_Count">
                                <div className="label-align-center p-1">
                               

                                    <ol className="workFlow_Count">
                                        <li className="workFlow_conditions workFlow-row position-relative">
                                            <a className="cursor-pointer" onClick={e=>addTopFilter(false)}>
                                                <span className="svgIcon"> <Icons iconType="AddPlusTwo" /> </span> Add Filter
                                            </a>
                                        </li>
                                    </ol>
                                </div>
                            </ol>
                        </div>
                    </div>
                    <div className="col-12 float-left">
                        <div className="clear"></div>
                         {filters!==null && filters.length>0?

                                
                            <ol className="workFlow_Count mb-0">
                               <li className="workFlow_conditions workFlow-row position-relative">
                                   
                                  <div className="clearfix">
                                     <div className="col-4 float-left"> Field Name </div>
                                     <div className="col-4 float-left"> Operator </div>
                                     <div className="col-3 float-left"> Value </div>
                                     <div className="float-right mr-2">
                                        <a className="cursor-pointer" onClick={addFilters}>
                                           <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 16 16" enableBackground="new 0 0 16 16">
                                              <path fill="#656F7D" d="M14.32,9.193H1.54c-0.63,0-1.141-0.51-1.141-1.14s0.51-1.141,1.141-1.141H14.32 c0.629,0,1.139,0.51,1.139,1.141S14.949,9.193,14.32,9.193z"></path>
                                              <path fill="#656F7D" d="M7.929,15.582c-0.63,0-1.141-0.51-1.141-1.139V1.664c0-0.63,0.51-1.141,1.141-1.141 c0.631,0,1.141,0.51,1.141,1.141v12.78C9.07,15.072,8.561,15.582,7.929,15.582z"></path>
                                           </svg>
                                        </a>
                                     </div>
                                  </div>
                               </li>
                            </ol>
                        :null}

                        <FiltersComponent
                            filters={filters}
                            windowFields={windowFields}
                            changeHandler={changeHandler}
                            addFilters={addFilters}
                            deleteFitler={deleteFitler}
                            isRelatedWindow={true}
                            fieldOptions={fieldOptions}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
               
                    <a onClick={toggleModel} className="btn btn-cancel" data-dismiss="modal"> Cancel </a> 
                    <a onClick={saveHandler} className="btn primary_bg" data-dismiss="modal"> Save </a> 
                
            </Modal.Footer>
		</Modal>
	);
}

export default CreateNew;